import React from 'react';
import PropTypes from 'prop-types';
import BaseComp from './baseComp';

// const Placeholder = () => <div />;

class Placeholder extends React.PureComponent {
    render() {
        return <div />;
    }
}

class LazyLoadOrigin extends BaseComp {
    static propTypes = {
        placeholder: PropTypes.func.isRequired,
        children: PropTypes.oneOfType([PropTypes.element.isRequired, PropTypes.arrayOf(PropTypes.element.isRequired)]),
        observer: PropTypes.object.isRequired,
        event: PropTypes.object.isRequired,
    };

    static defaultProps = {
        placeholder: Placeholder,
    };

    render() {
        const { placeholder: Placeholder } = this.props;
        const { isLoaded } = this.state;

        return !isLoaded ? <Placeholder /> : this.props.children;
    }
}

export default LazyLoadOrigin;
